import { useEffect, useRef } from 'react';
import UIExpandingTextArea from 'UIComponents/input/UIExpandingTextArea';
import { TEXT_AREA_HEIGHT } from './SharedStyleComponents';
import { jsx as _jsx } from "react/jsx-runtime";
const useFocusInputIfNecessary = (shouldFocus, inputRef) => {
  useEffect(() => {
    if (!shouldFocus) {
      return;
    }
    const inputEl = inputRef.current;
    if (inputEl) {
      inputEl.focus();
    }
  }, [shouldFocus, inputRef]);
};
export default function ScreenTextArea({
  updateContent,
  content,
  placeholder,
  focus = false,
  onKeyDown
}) {
  const inputRef = useRef(null);
  useFocusInputIfNecessary(focus, inputRef);
  return /*#__PURE__*/_jsx(UIExpandingTextArea, {
    use: "on-dark",
    value: content,
    inputRef: inputRef,
    onChange: e => {
      updateContent(e.target.value);
    },
    type: "text",
    placeholder: placeholder,
    resize: false,
    styled: false,
    minHeight: TEXT_AREA_HEIGHT,
    maxHeight: TEXT_AREA_HEIGHT,
    onKeyDown: onKeyDown
  });
}